import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import cargonzLogo from '../images/logo-cargonz.png'
import '../styles/Navegador.css'
import axios from 'axios'
import ruta from '../routes/api-routes'

class Navegador extends React.Component {

    state = {
        permitido: false,
        menuClassA: "",
        menuClassLink: ""
    }

    // This make a request to the API endpoint
    async componentDidMount() {
        try {
            // This just get data from the API
            const res = await axios.get(ruta.comprobar)
            let data = await res.data
            if(data === "permitido"){
                this.setState({
                    permitido: true,
                    menuClassA: "dropdown-item d-none",
                    menuClassLink: "dropdown-item"
                })
            }
            else {
                this.setState({
                    menuClassA: "dropdown-item",
                    menuClassLink: "dropdown-item d-none"
                })
            }
        } catch (error) {

        }
    }

    render(){
        let loginMenu = "https://cargonz-api.herokuapp.com/login/cargonz.netlify.com/menu"
        let logout = "https://cargonz-api.herokuapp.com/logout"
        return (
            <>
            <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top">
                <Link to="/"><img src={cargonzLogo} alt="logotipo" className="navegador-logo mx-4"/></Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mr-auto">
                            <li className="nav-item">
                                <NavLink className="nav-link" activeClassName="active" to="/inicio">Inicio</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" activeClassName="active" to="/tienda">Tienda</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" activeClassName="active" to="/cotizar">Cotizar</NavLink>
                            </li>
                            <li className="nav-item dropdown">
                                <Link className="nav-link dropdown-toggle" to="/" id="navbarDropdown" role="button" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                    Más
                                </Link>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <a className="dropdown-item" href="/">Contacto</a>
                                    <a className="dropdown-item" href="https://www.carmax.com/" rel="noopener noreferrer" target="_blank">Inspirado en...</a>
                                    <div className="dropdown-divider"></div>
                                    <a className={this.state.menuClassA || "dropdown-item"} href={loginMenu}>Menú de carros</a>
                                    <Link to="/menu" className={this.state.menuClassLink || "dropdown-item d-none"}>Administrar</Link>
                                </div>
                            </li>
                        </ul>
                        <a href={logout} className={this.props.usernameClass || "text-danger px-3 d-none"}>Cerrar sesión</a>
                    </div>
                </nav>
            </>
        )
    }    
}

export default Navegador